import * as React from 'react'

import { i18nKeyPrefix } from 'main/components/tour/i18n'
import { NativeLink, Strong, Text, typography } from 'main/ui'
import { momentFromDateAndTime } from 'main/util/moment'
import { useTranslation } from 'react-i18next'
import { LOCIZE_NAMESPACE } from '../../../../../../common'
import { ScheduleTourModal_school, ScheduleTourModal_tourOpenings } from '../../../common/gql'

interface IProps {
  school: ScheduleTourModal_school
  selectedOpening: ScheduleTourModal_tourOpenings
  onRequestChange: () => void
}

const PRE = `${i18nKeyPrefix}-SCHEDULE-MODAL-REVIEW-OPENING`

export default function OpeningSelectionReview(props: IProps) {
  const { school, selectedOpening, onRequestChange } = props
  const { t } = useTranslation(LOCIZE_NAMESPACE)
  const beginsAtMoment = momentFromDateAndTime(
    selectedOpening.date,
    selectedOpening.beginsAt,
    school.timezone,
  )

  return (
    <div>
      <Strong>{t(`${PRE}-TITLE`)}</Strong>
      <Text>
        {' '}
        {school.name}, {beginsAtMoment.format('dddd, MMMM D YYYY · h:mma')} ·{' '}
      </Text>
      <NativeLink css={{ fontWeight: typography.fontWeight.bold }} onClick={onRequestChange}>
        {t(`${PRE}-CHANGE`)}
      </NativeLink>
    </div>
  )
}
